export const style = {
  fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
};
